var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotate90DegreesCcw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.25 15.3999L6.15002 21.4999L12.2334 27.5999L18.3334 21.4999L12.25 15.3999Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2334 10.6833L1.43335 21.4999L12.25 32.2999L23.0667 21.4999L12.2334 10.6833V10.6833ZM12.2334 27.5999L6.15002 21.4999L12.25 15.3999L18.3334 21.4999L12.2334 27.5999ZM32.2667 11.0666C29.35 8.13327 25.5 6.6666 21.6667 6.6666V1.2666L14.6 8.33327L21.6667 15.3999V9.99993C24.65 9.99993 27.6334 11.1333 29.9167 13.4166C34.4667 17.9666 34.4667 25.3666 29.9167 29.9166C27.6334 32.1999 24.65 33.3333 21.6667 33.3333C20.05 33.3333 18.4334 32.9833 16.9334 32.3166L14.45 34.7999C16.7 36.0333 19.1834 36.6666 21.6667 36.6666C25.5 36.6666 29.35 35.1999 32.2667 32.2666C38.1334 26.4166 38.1334 16.9166 32.2667 11.0666V11.0666Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 6.15002,
    y1: 15.3999,
    x2: 20.0898,
    y2: 25.0671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4840A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 1.43335,
    y1: 1.2666,
    x2: 41.834,
    y2: 29.1905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4840A4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate90DegreesCcw);
export default __webpack_public_path__ + "static/media/rotate_90_degrees_ccw.a0d5a879d0a86004c43b95b26bfbce4a.svg";
export { ForwardRef as ReactComponent };